import * as d3 from "d3";
import { IZone } from "../types/IPitchProps";

export const createZone = (
  pitchGroup: d3.Selection<SVGGElement, any, null, undefined>,
  pitchWidth: number,
  pitchHeight: number,
  selectedAreas: string[],
  setSelectedAreas: React.Dispatch<React.SetStateAction<string[]>>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  onSelectedAreasChange: (selectedAreas: string[]) => void
): void => {
  const areas: IZone[] = [
    { height: pitchHeight / 4, id: "firstRect" },
    { height: (pitchHeight / 4) * 2, id: "middleRect" },
    { height: pitchHeight / 4, id: "lastRect" },
  ];
  let currentY = 0;
  const handleZoneClick = (event: any) => {
    const { target } = event;
    const rectId = target.id;
    const normalizedRectId = rectId.replace(/\s/g, ""); // Remove whitespace
    const selectedAreasWithoutSpaces = selectedAreas.map((position) => position.replace(/\s/g, ""));
    if (selectedAreasWithoutSpaces.includes(normalizedRectId)) {
      target.setAttribute("fill", "#C9F0B5");
      const index = selectedAreasWithoutSpaces.indexOf(normalizedRectId);
      selectedAreasWithoutSpaces.splice(index, 1);
    } else {
      //console.log(event)
      target.setAttribute("fill", "#00D1A8");
      selectedAreasWithoutSpaces.push(normalizedRectId);
    }
    setSelectedAreas([...selectedAreasWithoutSpaces]);
    onSelectedAreasChange(selectedAreasWithoutSpaces);
  };
  areas.forEach((area) => {
    pitchGroup
      .append("rect")
      .attr("id", area.id)
      .attr("x", 0)
      .attr("y", currentY)
      .attr("width", pitchWidth)
      .attr("height", area.height)
      .style("fill", "transparent");
    currentY += area.height;
  });
  const firstRect = pitchGroup.select("#firstRect");
  const firstRectWidth = parseFloat(firstRect.attr("width") || "0");
  const newRectWidth = firstRectWidth / 2;
  const firstRectY = parseFloat(firstRect.attr("y") || "0");
  const padding = 2;
  var points = [
    [xScale(0) + padding, yScale(0) + padding], // Top-left with padding
    [xScale(52.5) - padding, yScale(0) + padding], // Top-right with padding
    [xScale(52.5) - padding, yScale(16.92) - padding], // Bottom-right with padding
    [xScale(16.8) + padding, yScale(16.92) - padding], // Bottom-right with padding
    [xScale(16.8) + padding, yScale(12.92) - padding], // Bottom-left with padding
    [xScale(0) + padding, yScale(12.92) - padding], // Bottom-left with padding
  ];
  pitchGroup
    .append("polygon")
    .attr("id", "LeftWingDefence")
    .attr("points", points.join(" "))
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  pitchGroup
    .append("rect")
    .attr("id", "LeftWingAttack")
    .attr("x", newRectWidth + padding)
    .attr("y", firstRectY + padding)
    .attr("width", newRectWidth - 2 * padding)
    .attr("height", parseFloat(firstRect.attr("height") || "0") - 2 * padding)
    .attr("rx", 2)
    .attr("ry", 2)
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  firstRect.remove();
  const lastRect = pitchGroup.select("#lastRect");
  const lastRectWidth = parseFloat(lastRect.attr("width") || "0");
  const newLastRectWidth = lastRectWidth / 2;
  const lastRectY = parseFloat(lastRect.attr("y") || "0");
  var points = [
    [xScale(0) + padding, yScale(68) - padding],
    [xScale(52.5) - padding, yScale(68) - padding],
    [xScale(52.5) - padding, yScale(52.25) - padding],
    [xScale(16.8) + padding, yScale(52.25) - padding],
    [xScale(16.8) + padding, yScale(56.08) - padding],
    [xScale(0) + padding, yScale(56.08) - padding],
  ];
  pitchGroup
    .append("polygon")
    .attr("id", "RightWingDefence")
    .attr("points", points.join(" "))
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  pitchGroup
    .append("rect")
    .attr("id", "RightWingAttack")
    .attr("x", newRectWidth + padding)
    .attr("y", lastRectY + padding)
    .attr("width", newRectWidth - 2 * padding)
    .attr("height", parseFloat(lastRect.attr("height") || "0") - 2 * padding)
    .attr("rx", 2)
    .attr("ry", 2)
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  lastRect.remove();
  const middleRect = pitchGroup.select("#middleRect");
  const middleRectWidth = parseFloat(middleRect.attr("width") || "0");
  const newMiddleRectWidth: number = middleRectWidth / 4.5;
  const goalRectWidth = newMiddleRectWidth * 2;
  const restMiddleRectWidth: number = middleRectWidth - goalRectWidth;
  const middlerectY = middleRect.attr("y");
  pitchGroup
    .append("rect")
    .attr("id", "Goalkeeper")
    .attr("x", xScale(0) + 3)
    .attr("y", yScale(12.92) + 3)
    .attr("width", xScale(16.8) - xScale(0) - 2 * 3)
    .attr("height", yScale(55.08) - yScale(12.92) - 2 * 3)
    .attr("rx", 2)
    .attr("ry", 2)
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  pitchGroup
    .append("rect")
    .attr("id", "middleRect_right")
    .attr("x", goalRectWidth)
    .attr("y", middlerectY)
    .attr("width", restMiddleRectWidth)
    .attr("height", parseFloat(middleRect.attr("height") || "0"));
  middleRect.remove();
  const middleRightRect = pitchGroup.select("#middleRect_right");
  const middleRightRectWidth = parseFloat(middleRightRect.attr("width") || "0");
  const columnWidth = middleRightRectWidth / 3;
  const columnHeight = parseFloat(middleRightRect.attr("height")) / 2;
  const smallGridIDS: any = ["DefensiveMidfield", "CentralMidfield", "Attackingmidfield"];
  for (let i = 0; i < 3; i++) {
    pitchGroup
      .append("rect")
      .attr("id", smallGridIDS[i])
      .attr("x", parseFloat(middleRightRect.attr("x")) + i * (middleRightRectWidth / 4) - (pitchWidth < 245 ? 9 : 12))
      .attr("y", parseFloat(middleRightRect.attr("y")) + padding)
      .attr("width", middleRightRectWidth / 4 - 2 * padding)
      .attr("height", parseFloat(middleRightRect.attr("height")) - 2 * padding) // Use full height
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("fill", "#C9F0B5")
      .on("click", handleZoneClick)
      .style("cursor", "pointer");
  }
  pitchGroup
    .append("rect")
    .attr("id", "Attack")
    .attr("x", parseFloat(middleRightRect.attr("x")) + 2 * columnWidth + padding)
    .attr("y", parseFloat(middleRightRect.attr("y")) + padding)
    .attr("width", columnWidth - 2 * padding)
    .attr("height", parseFloat(middleRightRect.attr("height")) - 2 * padding)
    .attr("rx", 2)
    .attr("ry", 2)
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  pitchGroup
    .append("rect")
    .attr("id", "LeftcentralDefence")
    .attr("x", parseFloat(middleRightRect.attr("x")) + padding - (pitchWidth < 245 ? 68 : 84)) // Start from the beginning
    .attr("y", parseFloat(middleRightRect.attr("y")) + padding)
    .attr("width", middleRightRectWidth / 2.35 - 2 * padding)
    .attr("height", (parseFloat(middleRightRect.attr("height")) - 3 * padding) / 2)
    .attr("rx", 2)
    .attr("ry", 2)
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  pitchGroup
    .append("rect")
    .attr("id", "RightcentralDefence")
    .attr("x", parseFloat(middleRightRect.attr("x")) + padding - (pitchWidth < 245 ? 68 : 84)) // Same x as top box
    .attr("y", parseFloat(middleRightRect.attr("y")) + parseFloat(middleRightRect.attr("height")) / 2 + padding)
    .attr("width", middleRightRectWidth / 2.35 - 2 * padding)
    .attr("height", (parseFloat(middleRightRect.attr("height")) - 3 * padding) / 2)
    .attr("rx", 2)
    .attr("ry", 2)
    .attr("fill", "#C9F0B5")
    .on("click", handleZoneClick)
    .style("cursor", "pointer");
  middleRightRect.remove();
  selectedAreas.forEach((areaId) => {
    pitchGroup.select(`#${areaId.replace(/\s+/g, "")}`).attr("fill", "#00D1A8");
  });
};
